import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OurAuthService } from 'app/core/auth/auth.service';

/** Super admins must not use the company dashboard; send them to user management. */
export const superAdminDashboardRedirectGuard: CanActivateFn = () => {
    const auth = inject(OurAuthService);
    const router = inject(Router);

    if (auth.userRole === 'admin') {
        return router.parseUrl('/admin-users');
    }

    return true;
};
